module.exports = __webpack_public_path__ + "assets/img/Integrity_badge_Light_SE.fbc07c52.png";